/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import Modal from 'components/Modal.jsx';
import React from 'react';
import userAgent from 'lib/currentUserAgent';
import WebNotificationActions from 'notifications/WebNotificationActions';

import './WebNotificationTutorialModal.scss';

const WebNotificationTutorialModal = React.createClass({

  componentDidMount() {
    this.askForPermission();
  },

  askForPermission() {
    WebNotificationActions.askForPermission()
      .then(() => this.props.onRequestHide())
      .catch(e => console.error('WebNotificationActions.askForPermission failed', e));
  },

  renderAskButton() {
    if (userAgent.firefox()) {
      return (
        <Button
          className="WebNotificationTutorialModal-body-button"
          onClick={this.askForPermission}
          level="secondary"
          eventElementName="WebNotificationTutorialModal-body-button">
          Show dialog again
        </Button>
      );
    }
  },

  renderCloseLink() {
    if (!userAgent.safari()) {
      return (
        <Link
          className="WebNotificationTutorialModal-close"
          onClick={this.props.onRequestHide}
          eventElementName="WebNotificationTutorialModal-close">
          <Glyph name="close" size="large" solo />
        </Link>
      );
    }
  },

  renderImage() {
    if (userAgent.safari()) {
      return (
        <Image
          className="WebNotificationTutorialModal-body-image-up"
          src={require('assets/images/notifications/plane-flying-up.svg')}
        />
      );
    } else {
      return (
        <Image
          className="WebNotificationTutorialModal-body-image-left"
          src={require('assets/images/notifications/plane-flying-left.svg')}
        />
      );
    }
  },

  render() {
    return (
      <Modal className="WebNotificationTutorialModal">
        {this.renderCloseLink()}
        <Container className="WebNotificationTutorialModal-container" size="small">
          <BoxBody className="WebNotificationTutorialModal-body">
            {this.renderImage()}
            <div className="WebNotificationTutorialModal-body-title">
              Turn on desktop notifications
            </div>
            <div className="WebNotificationTutorialModal-body-subtext">
              Click &quot;Allow&quot; in the dialog to get notifications for new messages and updates.
            </div>
            {this.renderAskButton()}
          </BoxBody>
        </Container>
      </Modal>
    );
  },
});

export default WebNotificationTutorialModal;



// WEBPACK FOOTER //
// ./src/notifications/WebNotificationTutorialModal.jsx